import React from 'react'
import { AiOutlineClockCircle } from '@react-icons/all-files/ai/AiOutlineClockCircle'
import { FiTruck } from '@react-icons/all-files/fi/FiTruck'
import { GrLocation } from '@react-icons/all-files/gr/GrLocation'
import { GrMapLocation } from '@react-icons/all-files/gr/GrMapLocation'
import AudioAction from '../audio/AudioAction'
import Container from '../foundations/Container'
import styles from './BusinessInfoV2.module.scss'
import { BUSINESS_HOURS_DISPLAY } from '../../../content/businessHours'

const MIAMI_MAP = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d85279.76786666439!2d-80.18819877200482!3d25.972544745070756!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x641f16c240d54da2!2sMiami%20Sound%20Rental!5e0!3m2!1sen!2sus!4v1656608031734!5m2!1sen!2sus'
const ORLANDO_MAP = 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d56130.27280788302!2d-81.431191!3d28.445134!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e77fb418c8417d%3A0xe3ee1bf6f1075aa!2sMiami%20Sound%20Rental!5e0!3m2!1sen!2sus!4v1731515480989!5m2!1sen!2sus'

const InfoItem = ({ children, icon, title }) => (
  <div className={styles.infoItem}>
    <div className={styles.icon} aria-hidden='true'>
      {icon}
    </div>
    <div className={styles.itemContent}>
      <h3>{title}</h3>
      <div className={styles.rule} />
      {children}
    </div>
  </div>
)

const BusinessInfoV2 = ({ orlando, sectionId }) => (
  <section className={styles.section}>
    <Container width='wide' className={styles.container}>
      <h2 id={sectionId}>
        AV Rental Company in {orlando ? 'Orlando and Central Florida' : 'Miami & FT Lauderdale'}
      </h2>

      <div className={styles.layout}>
        <div className={styles.detailsCard}>
          <InfoItem icon={<GrLocation />} title='Our Location'>
            {orlando ? (
              <>
                <AudioAction mode='text' href='/orlando'>Orlando Branch</AudioAction>
                <p>8600 Commodity Cir #152<br /><br />Orlando, FL 32819</p>
              </>
            ) : (
              <p>We are located at 20227 NE 15th Ct, Miami FL 33179, on I-95 and Ives Dairy.</p>
            )}
          </InfoItem>

          <InfoItem icon={<GrMapLocation />} title='Service Area'>
            <p>
              {orlando
                ? 'Orlando, Tampa and the rest of Central Florida.'
                : 'Miami, Fort Lauderdale, Boca Raton, Palm Beach, and the rest of South Florida.'}
            </p>
          </InfoItem>

          <InfoItem icon={<FiTruck />} title='Delivery & Setup 24 / 7'>
            <p>We provide 24-hour, 7-day-a-week audiovisual production services. We also service last-minute requests.</p>
          </InfoItem>

          <InfoItem icon={<AiOutlineClockCircle />} title='Business Hours'>
            <ul className={styles.hours}>
              {BUSINESS_HOURS_DISPLAY.map(([day, hours]) => (
                <li key={day}><span>{day}:</span><span>{hours}</span></li>
              ))}
            </ul>
          </InfoItem>
        </div>

        <div className={styles.mapCard}>
          <iframe
            className={styles.map}
            title='Google Map'
            src={orlando ? ORLANDO_MAP : MIAMI_MAP}
            loading='lazy'
            referrerPolicy='no-referrer-when-downgrade'
          />
        </div>
      </div>
    </Container>
  </section>
)

export default BusinessInfoV2
